/*
  Sanftes Einblenden der Sektionen beim Scrollen.

  Bewusst zurueckhaltend gebaut:
  - Die Klasse wird per JS gesetzt, nicht im Markup. Faellt JS aus,
    ist trotzdem alles sichtbar - nichts versteckt sich dauerhaft.
  - Nur Sektionen, die beim Laden UNTER dem sichtbaren Bereich liegen,
    werden vorbereitet. Der Hero blendet also nicht ein, und es gibt
    kein Aufblitzen beim Seitenaufbau.
  - Kopfzeile, Ankuendigungsleiste und Fusszeile bleiben aussen vor.
  - Bei "Bewegung reduzieren" passiert gar nichts.
*/
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function start() {
    var sections = document.querySelectorAll('.shopify-section');
    if (!sections.length) return;

    var viewportBottom = window.innerHeight;
    var candidates = [];

    sections.forEach(function (section) {
      if (section.closest('.shopify-section-group-header-group')) return;
      if (section.closest('.shopify-section-group-footer-group')) return;
      if (section.classList.contains('section-header')) return;
      if (section.classList.contains('announcement-bar-section')) return;

      // nur was noch nicht zu sehen ist
      if (section.getBoundingClientRect().top < viewportBottom - 40) return;

      section.classList.add('tt-reveal');
      candidates.push(section);
    });

    if (!candidates.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('tt-reveal--in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.06 }
    );

    candidates.forEach(function (section) {
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
